"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxDownstreamWorkbooks = exports.getMaxDownstreamDatasources = void 0;
function getMaxDownstreamDatasources(resultData) {
    var maxDownstreamDatasources = resultData && resultData.maxDownstreamDatasources;
    var firstNode = maxDownstreamDatasources && maxDownstreamDatasources.nodes && maxDownstreamDatasources.nodes[0];
    var downstreamDatasourcesConnection = firstNode && firstNode.downstreamDatasourcesConnection;
    return downstreamDatasourcesConnection ? downstreamDatasourcesConnection.totalCount : null;
}
exports.getMaxDownstreamDatasources = getMaxDownstreamDatasources;
function getMaxDownstreamWorkbooks(resultData) {
    var maxDownstreamWorkbooks = resultData && resultData.maxDownstreamWorkbooks;
    var firstNode = maxDownstreamWorkbooks && maxDownstreamWorkbooks.nodes && maxDownstreamWorkbooks.nodes[0];
    var downstreamWorkbooksConnection = firstNode && firstNode.downstreamWorkbooksConnection;
    return downstreamWorkbooksConnection ? downstreamWorkbooksConnection.totalCount : null;
}
exports.getMaxDownstreamWorkbooks = getMaxDownstreamWorkbooks;
//# sourceMappingURL=MaxCountsFunctions.js.map